function Loader() {
  const loaderStyle = {
    width: '50px',
    height: '50px',
    background: 'linear-gradient(to right, #00BFFF, #008080)', // Gradient from blue to teal
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  };

  return <div style={loaderStyle}></div>;
}

export default Loader;

// Adding keyframes for the spin animation
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(
  `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`,
  styleSheet.cssRules.length,
);
